/*
 * The reference widget. Every other idea is written to look like this one: neutral
 * text, colour in the indicator only, the block centred in the box, a footer that
 * says what the numbers are. See STYLE.md.
 */
import { bind, type IdeaEntry } from './types';
import { KIT_V1_HEADER } from '../runtime/kit';

const KPI = `
const meta = { title: 'KPI', minWidth: 140, minHeight: 80, fps: 30, aspect: '3:2', preferredW: 3, settings: SYM.concat([SET.window, SET.decimals, SET.num('warn', 'Warn at'), SET.num('fault', 'Fault at'), SET.bool('invert', 'Limits are falling'), SET.num('target', 'Target')]) };
function setup(ctx) {
  const c = ctx.config;
  const read = ctx.sub(c.controllerId, c.symbolId);
  const windowMs = Math.max(5, Number(c.windowSec) || 300) * 1000;
  // Two windows: the one shown, and the one before it, so the change can be said against
  // "the same length of time before" rather than only against the window's first sample.
  const it = { label: String(c.label || c.symbolId || ''), unit: c.unit == null ? '' : String(c.unit), dec: c.decimals == null ? 1 : Number(c.decimals),
    warn: c.warn == null ? null : Number(c.warn), fault: c.fault == null ? null : Number(c.fault), invert: !!c.invert, target: c.target == null ? null : Number(c.target), w: window_(windowMs * 2), windowMs: windowMs };
  return function () {
    const b = ctx.size();
    const now = Date.now();
    it.w.push(read(), now);
    const nodes = [];
    kpi(nodes, { x: 0, y: 0, width: b.width, height: b.height }, it, now);
    return root(b, nodes);
  };
}
return { meta, setup };`;

export const REFERENCE_IDEAS: IdeaEntry[] = [
  { id: 'kpi', title: 'KPI', summary: 'One number, its change over the window, and a sparkline.', defaults: { windowSec: 300 }, minW: 2, minH: 2, aspect: '3:2', source: KIT_V1_HEADER + KPI,
    about: 'Binds one symbol. JS keeps the window and reads: the value with its unit, a state dot from `warn`/`fault` (`invert` for falling limits), the change since the window began as an arrow, min/avg/max of the window, a bar centred on the average showing where the value sits against it (the window extremes at the ends, `target` as a tick), and the history on the chart’s axes when the tile is tall enough. Hover any part for the figures; each part drops when the box is too small for it.',
    configKeys: ['controllerId', 'symbolId', 'label', 'unit', 'windowSec', 'decimals', 'warn', 'fault', 'invert', 'target'],
    demo: { config: { ...bind('cpu', 'CPU usage'), unit: '%', windowSec: 300, decimals: 1, warn: 60, fault: 85, target: 40 }, w: 4, h: 4 } },
];
